import classNames from 'classnames/bind';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';
import type { ProductLine } from 'types/store/invoice-state';
import styleIdentifiers from './ProductsDetail.module.scss';
import ProductsDetailItem from './ProductsDetailItem';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  products: ProductLine[];
};

export default function ProductsDetail({ products = [] }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles('ProductsDetail')}>
      <Panel withBorder title={t(i18nKeys.INVOICE.INVOICE_PRODUCTS)}>
        <table>
          <thead>
            <tr>
              <th className={styles('big')}>{t(i18nKeys.INVOICE.PRODUCT)}</th>
              <th>{t(i18nKeys.INVOICE.QTE)}</th>
              <th>{t(i18nKeys.PRICE)}</th>
              <th>{t(i18nKeys.TOTAL_NOT_VAT_PRICE)}</th>
              <th>{t(i18nKeys.INVOICE.DISCOUNT)}</th>
              <th>{t(i18nKeys.VAT)}</th>
              <th className={styles('right')}>{t(i18nKeys.TOTAL_VAT_PRICE)}</th>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <ProductsDetailItem key={product.id} productLine={product} />
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
